export default __webpack_public_path__ + "static/media/AvatarKids-05.be881d6a.png";